'use strict';
// "Crunched INI" parser — WI's compact binary form of an .ini file, used for
// .lvl (compiled missions) and .ini.pp (game.ini, forms.ini, GobTemplates.ini…).
// Layout (big-endian): a file is a sequence of sections.
//   Section: u16 offSecNext (bytes from this section's start to the next; 0 = last)
//            u16 cprop
//            char szSecName[] (NUL-terminated)
//            cprop × Prop
//   Prop:    char szName[] (NUL) ; char szValue[] (NUL)
// Anonymous list entries use a repeated key (e.g. "nil"); we keep ordered pairs.
// Reference: inicrunch/main.cpp (SecChunk/PropChunk), mpshared/ini.* .

function readCStr(buf, o) { let e = o; while (e < buf.length && buf[e] !== 0) e++; return [buf.toString('latin1', o, e), e + 1]; }

/** Parse a crunched-INI Buffer. Returns [{ name, props:[{key,value}] }, ...]. */
function parseCini(buf) {
  const sections = [];
  let o = 0;
  while (o + 4 <= buf.length) {
    const offNext = buf.readUInt16BE(o);
    const cprop = buf.readUInt16BE(o + 2);
    let [name, p] = readCStr(buf, o + 4);
    const props = [];
    for (let i = 0; i < cprop; i++) {
      let [k, p2] = readCStr(buf, p);
      let [v, p3] = readCStr(buf, p2);
      props.push({ key: k, value: v });
      p = p3;
    }
    sections.push({ name, props });
    if (offNext === 0) break;
    o += offNext;
  }
  return sections;
}

/** Convenience: sections -> { sectionName: { key: value } } (last value wins for dup keys). */
function ciniToObject(sections) {
  const o = {};
  for (const s of sections) { const m = o[s.name] || (o[s.name] = {}); for (const p of s.props) m[p.key] = p.value; }
  return o;
}

module.exports = { parseCini, ciniToObject };

if (require.main === module) {
  const fs = require('fs');
  const buf = fs.readFileSync(process.argv[2]);
  console.log(JSON.stringify(parseCini(buf), null, 2));
}
